import { createAsyncThunk } from "@reduxjs/toolkit";
import { deleteEmailCampaign, duplicateEmailCampaign, getDetailEmailCampaign, getEmailCampaigns, updateEmailCampaign, updateStatusEmailCampaign } from "services/campaign.service";


export const getCampaigns = createAsyncThunk("campaign/getCampaigns", async () => {
  try {
    const response = await getEmailCampaigns();
    return response;

  } catch (error) {
    console.error("Error fetching campaigns:", error);
    return error;
  }
});

export const updateStatusCampaign = createAsyncThunk("campaign/updateStatusCampaign", async ({ id, payload }: { id: string; payload?: any }) => {
  try {
    const response = await updateStatusEmailCampaign(id, payload);
    return response;
  } catch (error) {
    return error;
  }
});

export const updateCampaign = createAsyncThunk("campaign/updateCampaign", async ({ id, payload }: { id: string; payload?: any }) => {
  try {
    const response = await updateEmailCampaign(id, payload)

    return response;
  } catch (error) {
    return error;
  }
});

export const getDetailCampaign = createAsyncThunk("campaign/getDetailCampaign", async (id: string) => {
  try {
    const response = await getDetailEmailCampaign(id);
    return response;
  } catch (error) {
    return error;
  }
});

export const deleteCampaign = createAsyncThunk("campaign/deleteCampaign", async (id: string) => {
  try {
    const response = await deleteEmailCampaign(id)

    return response;
  } catch (error) {
    return error;
  }
});

export const duplicateCampaign = createAsyncThunk("campaign/duplicateCampaign", async (id: string) => {
  try {
    const response = await duplicateEmailCampaign(id)
    return response;
  } catch (error) {
    return error;
  }
});